import React, { Component, Fragment } from 'react';
import CollectionItem from './CollectionItem.js';
import Modal from '../../common/Modal.js';
import Slider from '../../common/Slider.js';
import ProductSlide from './ProductSlide.js';
import {baseUrl} from '../../utils/utils.js';

class Collections extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      selectedCollection: '',
      collections: [],
      products: []
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    fetch(baseUrl('api/collections/', true))
      .then(res => res.json())
      .then(
        (result) => this.setState({
          collections: result
        }),
        (error) => console.error('some error occurred..')
      );
  }

  openModal(id, title) {
    this.setState({
      showModal: true,
      selectedCollection: title
    });
    fetch(baseUrl(`api/products/?collection=${id}`, true))
      .then(res => res.json())
      .then(
        (result) => this.setState({
          products: result
        }),
        (error) => console.error('some error occurred..')
      );
  }

  closeModal() {
    this.setState({
      showModal: false
    });
  }

  render() {
    return (
      <Fragment>
        <h1>Collections</h1>
        {
          this.state.collections.length ?
          this.state.collections.map((item) => {
            return <CollectionItem {...item} key={item.id} handleClick={this.openModal}/>;
          })
          : 'Loading...'
        }
        {this.state.showModal && <Modal showModal={this.state.showModal} closeModal={this.closeModal} title={this.state.selectedCollection}>
          {
            this.state.products.length ?
            <Slider length={this.state.products.length} autoSlide={false}>
              {this.state.products.map((item) => {
                return (
                  <ProductSlide
                    {...item}
                    key={item.id}
                    handleTouchStart={this.props.handleTouchStart}
                    handleTouchEnd={this.props.handleTouchEnd}
                  />
                )
              })}
            </Slider>
            : 'Loading...'
          }
        </Modal>}
      </Fragment>
    );
  }
}

export default Collections;